import { message, Modal } from 'antd';
import dva from 'dva';
import * as Sentry from '@sentry/browser';
import createLoading from 'dva-loading';
import { createHashHistory } from 'history';
import ls from 'local-storage';
import appModel from './models/app';
import router from './router';
import './defaultProps';
import './theme/global.less';
import messages from './i18n';


const dev = window.Config['app.frontend_url'].includes('localhost') === true;
if (!dev) {
  Sentry.init({
    dsn: 'https://f08e58d8d7eb4b5ba8ccffb065ee7e85@sentry.711media.de/7',
    release: window.Config.version,
    environment: window.Config.environment,
    beforeSend: (event, hint) => {
      if (hint && hint.originalException && hint.originalException.statusCode === 499) {
        return null;
      }
      return event;
    },
    integrations: [
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}


ls.set('BRANCES_TYPE', window.Config['app.system.branch_type']);

// 1. Initialize
const app = dva({
  ...createLoading({
    effects: true,
  }),
  history: createHashHistory({
    getUserConfirmation(locale, callback) {
      const modal = Modal.confirm({
        title: messages[locale]['Common.Attention'],
        content: messages[locale]['Common.DiscardChanges'],
        okText: messages[locale]['Common.Agree'],
        onOk: () => {
          callback(true);
          modal.destroy();
        },
        cancelText: messages[locale]['Common.Cancel'],
        width: 500,
      });
    },
  }),
  onError(error) {
    message.error(error.message);
  },
});
// 2. Plugins
// app.use({});
// 3. Model
app.model(appModel);

// 4. Router
app.router(router);

// 5. Start
app.start('#root');



// WEBPACK FOOTER //
// ./src/index.js